/**
 * Initializes the Pendo analytics tracking with the current user and organization information.
 *
 * @param {Object} user - The current user object.
 * @param {Object} activeOrg - The active organization object.
 * @returns {void}
 */
const initPendo = (user, activeOrg) => {
  if (!user || !activeOrg) return;

  if (
    process.env.NODE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    window.pendo
  ) {
    try {
      window.pendo.initialize({
        visitor: {
          id: user.uuid,
          email: user.email,
          full_name: `${user.firstName} ${user.lastName}`,
        },
        account: {
          id: activeOrg.orgResourceId,
          name: activeOrg.name,
        },
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Pendo initialization error:', error);
    }
  }
};

export default initPendo;
